import { useState } from "react";
import TextHighlighter from "@/admin/atoms/TextHighlighter";
import { getViewArea } from "src/pages/api/user";
// import { KnowledgeBaseProp } from "src/services/dataTypeDefinition.type";
import KnowledgeBaseTab from "../KnowledgeBaseTab";
import { BtnVariant } from "../KnowledgeBaseTab/KnowledgeBaseTab";
import styles from "./KnowledgeBaseUserManagement.module.css";

// props: KnowledgeBaseProp
function KnowledgeBaseUserManagement(): JSX.Element {
  // const { searchTerm,searchIndex,setSearchIndex,setSearchResultLength } = props;
  // const { searchTerm  } = props;
  const searchTerm = "";

  const btnListArray = [
    {
      title: "Create User",
      bntActive: true,
    },
    {
      title: "View User",
      bntActive: false,
    },
    {
      title: "Reset User Password",
      bntActive: false,
    },
    {
      title: "Active & Inactive Users",
      bntActive: false,
    },
    {
      title: "Delete Users",
      bntActive: false,
    },
    {
      title: "Activity Log",
      bntActive: false,
    },
  ];

  const [btnList, setBntList] = useState<BtnVariant[]>(btnListArray);

  const switchState = (index2: number) => {
    setBntList(
      btnList.map((btnObject, index) => {
        if (index === index2) {
          return {
            title: btnObject.title,
            bntActive: true,
          };
        }
        return {
          title: btnObject.title,
          bntActive: false,
        };
      })
    );
  };

  // let frameElement: HTMLElement | null;
  // useEffect(()=>{
  //  frameElement = document.getElementById("knowledge-content");
  // },[])

  // const getViewArea=(tabClicked:string)=>{
  //     const element = document.getElementById(`scrollTab${tabClicked.replaceAll(" ","")}`);
  //     element?.scrollIntoView({ behavior: "smooth", block: "start" });
  // }

  //   function highlightFirstOccurrence(elementId:string, wordToHighlight:string) {
  //       const divElement = document.getElementById(elementId);
  //       const textContent = divElement?.textContent;
  //       const lowerCaseText = textContent?.toLowerCase();
  //       const wordsArray = lowerCaseText?.split(/\W+/).filter(word => word.length > 0);
  //       const targetWord = wordToHighlight;
  //       let count = 0;

  //       if(wordsArray){
  //          for (let i = 0; i < wordsArray.length; i++) {
  //             if (wordsArray[i] === targetWord.toLowerCase()) {
  //                 count++;
  //             }
  //         }
  //       }

  //       setSearchResultLength(count)
  //       setSearchIndex(0)

  // }

  // function highlightNthOccurrence(elementId:string, word:string, n:number) {
  //   console.log("n value....",n,word)
  //    if(n>0){
  //        const element = document.getElementById(elementId);

  //     if (!element) {
  //         console.error("Element not found.");
  //         return;
  //     }

  //     let text = element.innerHTML; // Use innerHTML to preserve other HTML structure
  //     let count = 0;
  //     let startIndex = -1;
  //     let currentSearchIndex = 0;

  //     if(word===""){

  //     }

  //     // Find the nth occurrence
  //     while (count < n) {
  //         const foundIndex = text.toLowerCase().indexOf(word.trim().toLowerCase(), currentSearchIndex);
  //         if (foundIndex === -1) {
  //             console.warn(`The word "${word}" does not appear ${n} times.`);
  //             return; // Word not found nth time
  //         }
  //         startIndex = foundIndex;
  //         currentSearchIndex = foundIndex + word.length;
  //         count++;
  //     }

  //     // Replace the nth occurrence with highlighted HTML
  //     if(count>0){
  //         const before = text.substring(0, startIndex);
  //         const highlighted = `<span style="background-color: #4856DD; ">${text.substring(startIndex, startIndex + word.length)}</span>`;
  //         const after = text.substring(startIndex + word.length);

  //         element.innerHTML = before + highlighted + after;
  //     }

  //    }

  // }

  // function highlightNthOccurrence22(elementId:string, word:string, n:number) {
  //     const element = document.getElementById(elementId);
  //     if (!element) {
  //         console.error("Element not found.");
  //         return;
  //     }

  //     let text = element.innerHTML;
  //     const regex = new RegExp(word, 'gi'); // Case-insensitive, global search
  //     let match;
  //     let count = 0;
  //     let startIndex = -1;
  //     let endIndex = -1;

  //     // Find the Nth occurrence
  //     while ((match = regex.exec(text)) !== null) {
  //         count++;
  //         if (count === n) {
  //             startIndex = match.index;
  //             endIndex = match.index + match[0].length;
  //             break;
  //         }

  //     }

  //     if (startIndex !== -1) {
  //         // Construct the new HTML with highlighting
  //         const highlightedText = text.substring(0, startIndex) +
  //                                 `<span id="${word}testsearch${n}" style="background-color: #4856DD; ">` +
  //                                 text.substring(startIndex, endIndex) +
  //                                 '</span>' +
  //                                 text.substring(endIndex);

  //         element.innerHTML = highlightedText;
  //     } else {
  //         console.log(`The ${n}th occurrence of '${word}' was not found.`);
  //     }
  // }

  // let frameElement: HTMLElement | null;
  // useEffect(()=>{
  //  frameElement = document.getElementById("knowledge-content");
  // },[])

  // useEffect(()=>{
  //   if(searchTerm!==""){
  //     highlightFirstOccurrence("knowledge-content", searchTerm);
  //   }
  // },[searchTerm])

  // useEffect(()=>{
  //    if(searchIndex>0){
  //     highlightNthOccurrence("knowledge-content", searchTerm, searchIndex);
  //    }

  // },[searchIndex])

  // function highlightSecondOccurrence(word:string, containerElement:HTMLElement) {
  //     const textContent = containerElement.innerHTML;
  //     const regex = new RegExp(word, 'gi'); // Case-insensitive, global search
  //     let matchCount = 0;
  //     let matchIndex = -1;

  //     // Find the index of the second occurrence
  //     let match;
  //     while ((match = regex.exec(textContent)) !== null) {
  //         if (matchCount === 1) { // Second occurrence (0-indexed)
  //             matchIndex = match.index;
  //             break;
  //         }
  //         matchCount++;
  //     }

  //     if (matchIndex !== -1) {
  //         // Construct the new HTML with highlighting
  //         const highlightedText = `<mark style="background-color: red;">${word}</mark>`;
  //         const newHTML = textContent.substring(0, matchIndex) +
  //                         highlightedText +
  //                         textContent.substring(matchIndex + word.length);
  //         containerElement.innerHTML = newHTML;
  //     }
  // }

  return (
    <div className={styles.frame}>
      <div className="font-bold text-[24px] text-[#262626] phone:text-[20px]">
        USER MANAGER
      </div>

      <div className={styles.innerFrame} id="knowledge-content">
        <div className=" text-[#434343]">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="The User Management Feature contains such functionalities as adding
            users, deleting users, activating users, deactivating users and
            resetting user's passwords. In this tab you can also view all
            users under your platform and view their activity logs."
            id="userManagerText1"
          />
        </div>

        <div>
          <KnowledgeBaseTab
            btnList={btnList}
            callBack={switchState}
            getViewArea={getViewArea}
          />
        </div>

        <div
          className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
          id="scrollTabCreateUser"
        >
          Create Users
        </div>

        {/* <CreateUserPic1  /> */}

        <img
          src="/images/knowledgebase-images/svgs/user-management/createUser1.svg"
          alt="create user"
          className="mt-4"
        />

        <div className="text-[#434343] py-5">
          <TextHighlighter
            searchValue={searchTerm}
            textContent='<div>
                This is the default page that appears if no user has been created under
                your platform. To create a user click on the 
                <span  style="font-weight: bold;"> "Create User" </span> button.
              </div>'
            id="userManagerText2"
          />
        </div>
        <img
          src="/images/knowledgebase-images/svgs/user-management/createUser2.svg"
          alt="create user"
          className="mt-4"
        />

        <div className="text-[#434343] mt-5">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<div>
              On the <span style='font-weight: bold;'>&quot;Create User&quot;</span> page Enter the
              user's first name, last name and the email address to be assigned
              to the user then click <span style='font-weight: bold;'>&quot;Save&quot;</span>. Upon
              creating this new user, a default password will be sent to the
              user's email address. This password is a temporary password with
              which the user will use to log in for the first time. After the user
              logs in for the first time, they will be required to create a password
              of their choice.
              </div>"
            id="userManagerText3"
          />
        </div>
        <div className="mt-4" id="userText4">
          <TextHighlighter
            searchValue={searchTerm}
            textContent='In case you need to add multiple users, you can click 
            <span style="font-weight: bold;">“Save and add another”</span> button to save
            the user you have already created but remain on the 
            <span style="font-weight: bold;">“Create User”</span> screen to create
            another user. If you wish to cancel the user creation process you can
            click on the <span style="font-weight: bold;">“Cancel”</span> button at the
            bottom left.'
            id="userManagerText4"
          />
        </div>
        <div className=" text-[#434343] font-bold mt-4">PLEASE NOTE:</div>

        <div id="userText6">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<ul style='list-style-type: disc; padding-left: 40px;'>
              <li>
                Tenants who are operating a Trial account are limited to only 10 users. An upgrade to Premium will be required for full access.
              </li>
              
            </ul>"
            id="userManagerText61a"
          />
        </div>

        <div
          className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
          id="scrollTabViewUser"
        >
          View Users
        </div>
        <img
          src="/images/knowledgebase-images/svgs/user-management/viewUser.svg"
          alt="view user"
          className="mt-4 "
        />
        <div className="mt-4" id="userText5">
          <TextHighlighter
            searchValue={searchTerm}
            textContent='To view all the users present on your platform, click on the 
            <span style="font-weight: bold;">“All Users”</span> tab. This will show a
            list of all users, both active and inactive users. To create a new user
            from this page, click on the 
            <span style="font-weight: bold;">“Create New User”</span> button at the top
            right-hand corner of the screen.'
            id="userManagerText5"
          />
        </div>
        <div className=" text-[#434343] font-bold mt-4">PLEASE NOTE:</div>

        <div id="userText6">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<ul style='list-style-type: disc; padding-left: 40px;'>
              <li>
                Under the User type column in the “All Users” screen there are three
                categories of users: Regular, Root User and Admin.
              </li>
              <li>“Regular” refers to regular users of the site.</li>
              <li>
                The Root User is the direct user who has firsthand relationship with
                Myedvault as a tenant.
              </li>
              <li>
                Admin refers to users who have been assigned admin functions by the
                Root User. Admin functions could include being able to add users,
                delete users, render users inactive, change user's passwords
                etc.
              </li>
              <li>
                When the Root user assigns Admin function to a user, they decide
                what roles they want the Admin in question to perform. For example,
                a Root User can give an admin role to a user to be able to only add
                and delete users but not reset passwords.
              </li>
            </ul>"
            id="userManagerText6"
          />
        </div>
        <div
          className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold px-5 rounded-lg bg-[#E5E7EB]"
          id="scrollTabResetUserPassword"
        >
          Reset User Password
        </div>
        <img
          src="/images/knowledgebase-images/svgs/user-management/reset-user-password.svg"
          alt="reset password"
          className="mt-4"
        />
        <div id="userText7 mt-4">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<div>
              To reset a user's password click on the edit icon by the right of
            the user's name on the
            <span  style='font-weight: bold;'>&quot;All users&quot;</span> screen.
            </div>"
            id="userManagerText7"
          />
        </div>
        <img
          src="/images/knowledgebase-images/svgs/user-management/reset-password-screen2.svg"
          alt="all users"
          className="mt-10"
        />
        <div className="text-[#434343] mt-4" id="userText8">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<div>
              On the selected user's details page, click on the
            <span style='font-weight: bold;'>&quot;Reset Password&quot;</span> button to reset the
            user's password. A new password will be created for the user to
            sign in with. This password will be a temporary password with which the
            user will use to log in for the first time. Upon their first login, the
            user will be required to create a password of their choice.
            </div>"
            id="userManagerText8"
          />
        </div>
        <div
          className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
          id="scrollTabActive&InactiveUsers"
        >
          Active and Inactive Users
        </div>
        <div className="text-[#434343] mt-4" id="userText9">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="This can be an alternative to deleting users."
            id="userManagerText9"
          />
        </div>
        <img
          src="/images/knowledgebase-images/svgs/user-management/activate-and-deactivate-user.svg"
          alt="activate user"
          className="mt-10"
        />

        <div className="mt-10" id="userText10">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<div>To make a user inactive, select the user in the 
            <span style='font-weight: bold;'>&quot;All Users&quot;</span> screen. Then on the user
            details page, click on <span style='font-weight: bold;'>&quot;Inactive&quot;</span>.
            This will make the user inactive instead of deleting them. In a case
            where you wish to make the user active again, select the user and click
            on <span style='font-weight: bold;'>&quot;Active&quot;</span>.
            </div>"
            id="userManagerText10"
          />
        </div>
        <div className="font-bold mt-4">PLEASE NOTE:</div>
        <div id="userText11">
          <TextHighlighter
            searchValue={searchTerm}
            textContent='<ul style="list-style-type: disc; padding-left: 40px;">
              <li>
                Inactive users will still be among 
                <span className="font-bold">“All users”</span> but will not be able
                to access all the functionalities such as videos in the video
                library, events, courses etc.
              </li>
              <li>
                When inactive users become active, they will have access to all the
                functionalities as previously.
              </li>
            </ul>'
            id="userManagerText11"
          />
        </div>
        <div
          className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
          id="scrollTabDeleteUsers"
        >
          Delete Users
        </div>
        <img
          src="/images/knowledgebase-images/svgs/user-management/deleteUser.svg"
          alt="delete user"
          className="mt-10"
        />
        <div className="mt-4" id="userText12">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<div>
              To delete a user, click on the delete icon beside the user's name
            on the <span style='font-weight: bold;'>&quot;All Users&quot;</span> list.
            </div>"
            id="userManagerText12"
          />
        </div>
        <img
          src="/images/knowledgebase-images/svgs/user-management/deleteAllUser.svg"
          alt="delete user"
          className="mt-10"
        />

        <div className="mt-10" id="userText13">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="You can also delete a user by clicking on the edit icon, then clicking
            on the delete button at the bottom left on the selected user's
            details screen."
            id="userManagerText13"
          />
        </div>
        <div className="font-bold mt-4">PLEASE NOTE:</div>
        <div id="userText14">
          <TextHighlighter
            searchValue={searchTerm}
            textContent='<ul style="list-style-type: disc; padding-left: 40px;">
              <li>
                Deleted users will not be among your
                <span className="font-bold">“All Users”</span> and will not have any
                access to the platform.
              </li>
              <li>
                All history and activity logs of deleted users will be deleted as
                well.
              </li>
              <li>
                In a case where a formerly deleted user is recreated with the same
                email, they still will not have access to the details in their
                former account. They have to start afresh.
              </li>
              <li>
                <span className="font-bold">“Inactive Users”</span> is an
                alternative for deleting a user in case you want to keep the
                user&#39;s records, their activity logs and history.
              </li>
            </ul>'
            id="userManagerText14"
          />
        </div>

        <div
          className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
          id="scrollTabActivityLog"
        >
          Activity Log
        </div>
        <img
          src="/images/knowledgebase-images/svgs/user-management/activityLog.svg"
          alt="activity log"
          className="mt-10"
        />

        <div
          className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
          id="scrollTabUserGroup"
        >
          User Group
        </div>

        <div className="mt-4" id="userText12">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<div>
              The User Group feature is helpful when you want a particular course to be available to only a specific set of users.
            </div>"
            id="userGroup1"
          />
        </div>

        <img
          src="/images/knowledgebase-images/svgs/user-management/userGroup1.svg"
          alt="activity log"
          className="mt-10"
        />

        <div className="mt-4" id="userText12">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<div>
              This is the default page that appears when no User group has been added. To add a new User group select the “User Group” tab and click the <span style='font-weight: bold;'>“Create Group”</span> button. 
            </div>"
            id="userGroup1"
          />
        </div>

        <div
          className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
          id="scrollTabUserGroup"
        >
          Create User Groups
        </div>
        <div className="mt-4" id="userText12">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<div>
             A pop-up appears where you are to input the group name and the description. Having done that, click the <span style='font-weight: bold;'>“Save”</span> button by the bottom right-hand corner.
            </div>"
            id="userGroup1"
          />
        </div>
        <img
          src="/images/knowledgebase-images/svgs/user-management/create-user-group.svg"
          alt="activity log"
          className="mt-10"
        />

        <div
          className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
          id="scrollTabUserGroup"
        >
          Edit User Groups
        </div>
        <img
          src="/images/knowledgebase-images/svgs/user-management/edit-user-group.svg"
          alt="activity log"
          className="mt-10"
        />
        <div className="mt-4" id="userText12">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<div>
             To edit a user group, go to the User Groups screen and click on the edit icon next to the user group you wish to edit.
            </div>"
            id="userGroup1b"
          />
        </div>

        <img
          src="/images/knowledgebase-images/svgs/user-management/edit-user-group2.svg"
          alt="activity log"
          className="mt-10"
        />
        <div className="mt-4" id="userText12">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<div>
             This screen then appears where you can view the learners and courses under each user group. To do this, switch between the <span style='font-weight: bold;'>“Learners”</span> and <span style='font-weight: bold;'>“Courses”</span> tab at the top. To edit the user Group details, click on the <span style='font-weight: bold;'>“Edit group”</span> button at the top right-hand corner of the screen. You can also remove a user from a User Group from this screen. To do this, click on the <span style='font-weight: bold;'>“Remove”</span> button at the right-hand side of the user.
            </div>"
            id="userGroup1a"
          />
        </div>
        <div className="font-bold mt-4">PLEASE NOTE:</div>
        <div id="userText14">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<ul style='list-style-type: disc; padding-left: 40px;'>
              <li>
                Removing a user from a user group automatically allocates the user to the unassigned user group. When this happens, such a user will be unable to access courses added to that user group in the future. 
              </li>
              <li>
                Removing a course from a user group automatically allocates the course to an unassigned user group. When this happens, new users added to that user group will be unable to access that course and its content.
              </li>
              <li>
                Removing a course from a user group and adding it to another user group means that all members of the new user group will be able to access the course and its content.
              </li>
              
            </ul>"
            id="userManagerText14a"
          />
        </div>

        <div
          className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
          id="scrollTabUserGroup"
        >
          Delete User Groups
        </div>
        <img
          src="/images/knowledgebase-images/svgs/user-management/delete-user-group.svg"
          alt="activity log"
          className="mt-10"
        />

        <div className="mt-4" id="userText12">
          <TextHighlighter
            searchValue={searchTerm}
            textContent="<div>
             To delete a user group, click on the delete icon by the right hand corner of the user group on the User Groups screen.
            </div>"
            id="userGroup1a1"
          />
        </div>
      </div>
    </div>
  );
}

export default KnowledgeBaseUserManagement;
